/**
 * Arena Generator
 * Open rectangular area with optional pillars — good for testing visibility.
 */

import type { GridMap, GeneratorConfig } from '../types';
import { createGrid, carveRoom, addEntity } from '../grid';
import { SeededRandom } from '../random';

export function generateArena(config: GeneratorConfig): GridMap {
  const { width, height, seed } = config;
  const spacing = config.pillarSpacing ?? 4;
  const rng = new SeededRandom(seed);

  const map = createGrid(width, height, 'wall');
  map.seed = seed;
  map.name = 'Arena';

  // Carve the interior (1-cell wall border)
  carveRoom(map, 1, 1, width - 2, height - 2);

  // Place pillars at regular intervals with some randomness
  if (spacing > 0) {
    for (let y = spacing; y < height - 1; y += spacing) {
      for (let x = spacing; x < width - 1; x += spacing) {
        // Skip some pillars randomly for variety
        if (rng.bool(0.7)) {
          map.cells[y][x].terrain = 'wall';
        }
      }
    }
  }

  // Place player at center
  const cx = Math.floor(width / 2);
  const cy = Math.floor(height / 2);
  // Ensure center is floor
  map.cells[cy][cx].terrain = 'floor';

  return addEntity(map, {
    id: 'player',
    x: cx, y: cy,
    type: 'player',
    name: 'Player',
    lightRadius: 12,
  });
}
